if (!customElements.get("taxes-location")) {
  customElements.define(
    "taxes-location",
    class TaxesLocation extends HTMLElement {
      constructor() {
        super();
        this.fetchIpInfo();
        this.displayTaxMessage();
      }

      fetchIpInfo() {
        fetch("https://ipinfo.io/json?token=8f3e99c3ff0b67")
          .then((response) => response.json())
          .then((data) => {
            sessionStorage.setItem("ipInfo", JSON.stringify(data));
          })
          .catch((error) => console.error(error));
      }

      displayTaxMessage() {
        const ipInfo = JSON.parse(sessionStorage.getItem("ipInfo"));

        console.log(ipInfo);

        if (ipInfo && ipInfo.country) {
          const taxesIncluded = [
            "AT", // Austria
            "BE", // Bélgica
            "BG", // Bulgaria
            "HR", // Croacia
            "CY", // Chipre
            "CZ", // República Checa
            "DK", // Dinamarca
            "EE", // Estonia
            "FI", // Finlandia
            "FR", // Francia
            "DE", // Alemania
            "GR", // Grecia
            "HU", // Hungría
            "IE", // Irlanda
            "IT", // Italia
            "LV", // Letonia
            "LT", // Lituania
            "LU", // Luxemburgo
            "MT", // Malta
            "NL", // Países Bajos
            "PL", // Polonia
            "PT", // Portugal
            "RO", // Rumanía
            "SK", // Eslovaquia
            "SI", // Eslovenia
            "ES", // España
            "SE", // Suecia
          ];

          if (taxesIncluded.includes(ipInfo.country)) {
            document
              .getElementById("taxes-included-message")
              .classList.remove("hidden");
          } else {
            document
              .getElementById("taxes-excluded-message")
              .classList.remove("hidden");
          }
        }
      }
    }
  );
}

if (!customElements.get("taxes-location")) {
  customElements.define("taxes-location", TaxesLocation);
}
